// extracted by mini-css-extract-plugin
export default {"container":"ApplyChangesModal_container__rxTBD","buttons":"ApplyChangesModal_buttons__GjsDc","text":"ApplyChangesModal_text__oTTv7"};